export default {
  // Navigation
  nav_home: 'Início',
  nav_dashboard: 'Painel',
  nav_orders: 'Pedidos',
  nav_wallet: 'Carteira',
  nav_analytics: 'Estatísticas',
  nav_referral: 'Indicações',
  nav_account: 'Conta',
  nav_notifications: 'Notificações',
  nav_logout: 'Sair',
  nav_login: 'Entrar',
  nav_signup: 'Cadastre-se',
  nav_deposit_requests: 'Pedidos de Depósito',
  nav_withdraw_requests: 'Pedidos de Saque',
  nav_support_ticket: 'Ticket de Suporte',
  nav_system_logs: 'Logs do Sistema',
  nav_announcements: 'Avisos',
  nav_activity_logs: 'Logs de Atividade',
  nav_settings: 'Configurações',
  nav_section_main: 'Principal',
  nav_user_active: 'Ativo agora',
  nav_more: 'Mais',
  nav_logout_confirm: 'Deseja realmente sair?',
  nav_language: 'Idioma',

  // Dashboard
  dashboard_welcome: 'Bem-vindo de volta',
  dashboard_total_earnings: 'Ganhos Totais',
  dashboard_pending_orders: 'Pedidos Pendentes',
  dashboard_completed_orders: 'Pedidos Concluídos',
  dashboard_commission_rate: 'Taxa de Comissão',
  dashboard_quick_actions: 'Ações Rápidas',
  dashboard_recent_orders: 'Pedidos Recentes',
  dashboard_recent_activity: 'Atividade Recente',
  dashboard_wallet_balance: 'Saldo da Carteira',
  dashboard_deposit: 'Depositar',
  dashboard_withdraw: 'Sacar',
  dashboard_view_all: 'Ver Tudo',
  greeting_morning: 'Bom Dia',
  greeting_afternoon: 'Boa Tarde',
  greeting_evening: 'Boa Noite',
  dashboard_greeting_desc: 'Acompanhe seus ganhos, conclua pedidos e gerencie sua conta em um só lugar. Sua jornada de sucesso continua aqui!',

  // Dashboard Stats
  stats_available_balance: 'Saldo Disponível',
  stats_total_withdrawn: 'Total Sacado',
  stats_total_deposit: 'Total Depositado',
  stats_pending_orders: 'Pedidos Pendentes',
  stats_orders_suffix: ' pedidos',
  stats_task_earnings: 'Ganhos de Tarefas',
  stats_lifetime_earning: 'Ganhos Totais',

  // Orders
  orders_title: 'Meus Pedidos',
  orders_all: 'Todos os Pedidos',
  orders_pending: 'Pendente',
  orders_completed: 'Concluído',
  orders_cancelled: 'Cancelado',
  orders_order_id: 'ID do Pedido',
  orders_platform: 'Plataforma',
  orders_amount: 'Valor',
  orders_commission: 'Comissão',
  orders_status: 'Status',
  orders_date: 'Data',
  orders_no_orders: 'Nenhum pedido encontrado',
  orders_step_1: 'Revisando detalhes do produto',
  orders_step_2: 'Verificando informações do pedido',
  orders_step_3: 'Conectando à plataforma',
  orders_step_4: 'Enviando promoção',
  orders_step_5: 'Indexação SEO',
  orders_step_6: 'Aumentando visibilidade',
  orders_step_7: 'Finalização e confirmação',
  orders_btn_optimize: 'Otimizar pedido',
  orders_btn_claim_commission: 'Reclame a comissão',
  orders_btn_task_completed: 'Tarefa concluída',
  orders_price_label: 'Preço do pedido',
  orders_commission_rate_label: 'Taxa de comissão',

  // Wallet
  wallet_title: 'Minha Carteira',
  wallet_available_balance: 'Saldo Disponível',
  wallet_pending_balance: 'Saldo Pendente',
  wallet_total_withdrawn: 'Total Sacado',
  wallet_deposit_now: 'Depositar Agora',
  wallet_withdraw_now: 'Sacar Agora',
  wallet_transaction_history: 'Histórico de Transações',
  wallet_deposit_history: "Deposit History",
  wallet_withdrawal_history: 'Histórico de Saques',
  wallet_deposit_desc: "Adicione dinheiro à sua carteira usando os métodos de pagamento disponíveis.",
  wallet_no_deposits: "Nenhum depósito encontrado.",
  wallet_withdraw_history: "Histórico de saques",
  wallet_withdraw_desc: "Retire dinheiro da sua carteira.",
  wallet_no_withdrawals: "Nenhum saque encontrado.",
  wallet_no_withdrawals_desc: "Você ainda não fez retiradas.",
  withdrawal_restricted_title: 'Retirada Restrita',
  withdrawal_restricted_message: 'As retiradas não estão disponíveis no momento para sua conta. Entre em contato com o suporte ao cliente para mais informações.',

  // Analytics
  analytics_title: 'Estatísticas',
  analytics_earnings_overview: 'Visão Geral de Ganhos',
  analytics_platform_breakdown: 'Divisão por Plataforma',
  analytics_performance_metrics: 'Métricas de Desempenho',
  analytics_top_products: 'Principais Produtos',
  analytics_this_month: 'Este Mês',
  analytics_last_month: 'Mês Passado',
  analytics_total_revenue: 'Receita Total',
  analytics_avg_order_value: 'Valor Médio do Pedido',

  // Referral
  referral_title: 'Programa de Indicação',
  referral_your_code: 'Seu Código de Indicação',
  referral_copy_code: 'Copiar Código',
  referral_share_link: 'Compartilhar Link',
  referral_total_referrals: 'Total de Indicações',
  referral_active_referrals: 'Indicações Ativas',
  referral_referral_earnings: 'Ganhos de Indicação',
  referral_invite_friends: 'Convidar Amigos',

  // Account
  account_title: 'Configurações da Conta',
  account_profile: 'Perfil',
  account_security: 'Sicherheit',
  account_notifications: 'Notificações',
  account_kyc: 'Verificação KYC',
  account_phone: 'Número de Telefone',
  account_two_factor: 'Autenticação de Dois Fatores',
  account_save_changes: 'Salvar Alterações',
  account_cancel: 'Cancelar',

  // Auth & Common
  auth_email: 'E-mail',
  auth_password: 'Senha',
  auth_confirm_password: 'Confirmar Senha',
  auth_forgot_password: 'Esqueceu a senha?',
  auth_remember_me: 'Lembrar de mim',
  auth_login_button: 'Entrar',
  auth_signup_button: 'Cadastre-se',
  auth_already_have_account: 'Já tem uma conta?',
  auth_dont_have_account: "Não tem uma conta?",
  auth_reset_password: 'Redefinir Senha',
  auth_verify_email: 'Verificar E-mail',
  auth_live_platform: 'Plataforma ao Vivo',
  auth_security_verification: 'Verificação de Segurança',
  auth_captcha_refresh: 'Atualizar',
  auth_captcha_placeholder: 'Resultado',
  auth_captcha_error: 'Soma incorreta, tente novamente',
  auth_branding_title: 'Transforme Promoções em',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Renda Real',
  auth_branding_desc: 'Junte-se a milhares de promotores que ganham comissões diárias das principais marcas de e-commerce do mundo.',
  auth_sign_in_to_account: 'Entre na sua conta do {{system_name}}',
  auth_email_placeholder: 'voce@exemplo.com',
  auth_password_placeholder: 'Digite sua senha',
  auth_signing_in: 'Entrando...',
  auth_free_to_join: 'Cadastro Gratuito',
  auth_signup_branding_title: 'Comece a Ganhar',
  auth_signup_branding_highlight: 'Desde o Primeiro Dia',
  auth_signup_branding_desc: 'Não é necessária experiência. Cadastre-se em 2 minutos e comece a completar tarefas para as principais marcas de e-commerce.',
  auth_how_it_works: 'Como funciona',
  auth_signup_desc: 'Junte-se ao {{system_name}} e comece a ganhar comissões hoje — é grátis!',
  auth_step_1: 'Crie sua conta gratuita',
  auth_step_2: 'Procure e aceite tarefas',
  auth_step_3: 'Conclua e ganhe comissões',
  auth_signup_step_1_title: 'Criar Conta',
  auth_signup_step_1_desc: 'Inicie sua jornada',
  auth_signup_step_2_title: 'Completar Tarefas',
  auth_signup_step_2_desc: 'Ganhe comissões diárias',
  auth_signup_step_3_title: 'Sacar Fundos',
  auth_signup_step_3_desc: 'Saques rápidos e seguros',
  auth_benefit_1_title: 'Seguro e Confiável',
  auth_benefit_1_desc: 'Segurança de nível bancário para seus ganhos',
  auth_benefit_2_title: 'Pagamentos Instantâneos',
  auth_benefit_2_desc: 'Saque ganhos em até 24 horas',
  auth_benefit_3_title: 'Comunidade Global',
  auth_benefit_3_desc: 'Junte-se a mais de 12.000 promotores ativos',
  auth_benefit_4_title: 'Suporte 24/7',
  auth_benefit_4_desc: 'Obtenha ajuda sempre que precisar',
  auth_strength_weak: 'Fraca',
  auth_strength_fair: 'Regular',
  auth_strength_good: 'Boa',
  auth_strength_strong: 'Forte',
  auth_password_strength: 'Força da senha: {{strength}}',
  auth_social_proof: 'Junte-se a mais de {{count}} ganhadores',
  auth_passwords_match: 'As senhas coincidem',
  auth_creating_account: 'Criando conta...',
  auth_phone_number: 'Número de Telefone',
  auth_phone_optional: '(Opcional)',
  auth_phone_placeholder: 'Seu número de telefone',
  auth_full_name: 'Nome Completo',
  auth_full_name_placeholder: 'João Silva',
  auth_password_min_chars: 'Pelo menos 8 caracteres',
  auth_confirm_password_placeholder: 'Repita sua senha',
  auth_agree_to: 'Eu concordo com os',
  auth_terms_of_service: 'Termos de Serviço',
  auth_privacy_policy: 'Política de Privacidade',
  auth_and: 'e',
  auth_create_free_account: 'Criar Conta Gratuita',

  common_loading: 'Carregando...',
  common_save: 'Salvar',
  common_cancel: 'Cancelar',
  common_delete: 'Excluir',
  common_edit: 'Editar',
  common_view: 'Ver',
  common_search: 'Pesquisar',
  common_filter: 'Filtrar',
  common_export: 'Exportar',
  common_import: 'Importar',
  common_submit: 'Enviar',
  common_close: 'Fechar',
  common_confirm: 'Confirmar',
  common_success: 'Sucesso',
  common_error: 'Erro',
  common_warning: 'Aviso',
  common_announcement: 'Comunicado',

  val_full_name_required: 'Nome completo é obrigatório',
  val_email_required: 'E-mail é obrigatório',
  val_password_required: 'Senha é obrigatória',
  val_password_min: 'A senha deve ter pelo menos 8 caracteres',
  val_passwords_dont_match: 'As senhas não coincidem',
  security_pin_6_err: 'O PIN deve ter exatamente 6 dígitos.',
  security_pin_digit_err: 'O PIN deve conter apenas dígitos.',
  val_agree_terms: 'Você deve concordar com os termos',
  val_conn_error: 'Erro de conexão. Tente novamente.',

  // Homepage
  home_hero_title: 'Ganhe Comissões das Melhores Plataformas de E-Commerce',
  home_hero_subtitle: 'Junte-se a milhares de usuários ganhando comissões diárias da Walmart, eBay e AliExpress',
  home_get_started: 'Começar Agora',
  home_learn_more: 'Saiba Mais',
  home_how_it_works: 'Como Funciona',
  home_features: 'Recursos',
  home_why_choose_us: 'Por que nos escolher',
  home_features_title: 'Recursos Poderosos',
  home_features_subtitle: 'Tudo o que você precisa para começar a ganhar online. Construído com o seu sucesso em mente.',
  home_commission_tiers: 'Níveis de Comissão',
  home_testimonials: 'O que nossos usuários dizem',
  home_faq: 'Perguntas Frequentes',
  home_cta_title: 'Pronto para começar a ganhar?',
  home_cta_subtitle: 'Junte-se à nossa comunidade hoje e comece a ganhar comissões',
  home_trusted_partner: 'Plataformas Parceiras Confiáveis',
  home_secure_platform: 'Plataforma Segura',
  home_instant_payouts: 'Pagamentos Instantâneos',
  home_active_users: 'Usuários Ativos',
  home_paid_out: 'Pago',
  home_total_paid_out: 'Total Pago',
  home_user_rating: 'Avaliação dos Usuários',
  home_countries: 'Países',
  home_commission_badge: 'Potencial de Ganhos',
  home_commission_title: 'Taxas de Comissão',
  home_commission_desc: 'Um saldo maior desbloqueia melhores taxas de comissão. Cada sessão atribui exatamente 25 pedidos — complete até 4 sessões diárias para ganhos máximos.',
  home_tier_popular: 'Mais Popular',
  home_tier_commission_per_order: 'Comissão Por Pedido',
  home_tier_earn_examples: 'Exemplos de Ganhos:',
  home_tier_order: 'pedido',
  home_tier_batch_earn: 'Ganho por lote de 25 pedidos:',
  home_tier_daily_potential: 'Potencial Diário (4 lotes × 25 pedidos)',
  home_tier_max_daily: 'Até 100 pedidos por dia',
  home_tier_benefit_1: '25 pedidos por lote',
  home_tier_benefit_2: 'Máximo de 4 lotes por dia',
  home_tier_benefit_3: 'Crédito de comissão instantâneo',
  home_tier_above: 'Acima de',
  home_tier_no_tiers: 'Nenhum nível de comissão encontrado.',

  // Comparison Section
  home_compare_badge: 'O Diferencial',
  home_compare_title: 'Por Que Somos Mejores',
  home_compare_subtitle: 'Compare nossa plataforma com empregos tradicionais de meio período e veja por que milhares nos escolhem.',
  home_compare_feature: 'Recurso',
  home_compare_traditional: 'Empregos Tradicionais',
  home_compare_our_platform: 'Nossa Plataforma',
  home_compare_f1: 'Flexibilidade',
  home_compare_f1_trad: 'Horários fixos',
  home_compare_f1_our: 'Trabalhe a qualquer hora, em qualquer lugar',
  home_compare_f2: 'Pagamentos',
  home_compare_f2_trad: 'Mensais ou Quinzenais',
  home_compare_f2_our: 'Instantâneo / No mesmo dia',
  home_compare_f3: 'Requisitos',
  home_compare_f3_trad: 'Experiência/Currículo/Entrevista',
  home_compare_f3_our: 'Nenhum - Apenas um smartphone',
  home_compare_f4: 'Crescimento',
  home_compare_f4_trad: 'Aumentos anuais fixos',
  home_compare_f4_our: 'Crescimento ilimitado por níveis',

  // Testimonials
  home_testi_badge: 'Histórias de Sucesso',
  home_testi_title: 'Confiado por Milhares',
  home_testi_subtitle: 'Ouça nossa comunidade global de promotores que transformaram sua renda.',
  home_testi_no_stories: 'Nenhuma história de sucesso disponível ainda.',
  home_testi_total_earned: 'Total Ganho',
  home_testi_time_period: 'Período',
  home_testi_verified: 'Usuário Verificado',
  home_testi_avg_rating: 'Avaliação Média',
  home_testi_satisfaction_rate: 'Taxa de Satisfação',
  home_testi_support_available: 'Suporte Disponível',

  // FAQ
  home_faq_badge: 'Suporte',
  home_faq_title: 'Dúvidas Comuns',
  home_faq_subtitle: 'Tudo o que você precisa saber para começar e ganhar.',
  home_faq_no_data: 'Nenhuma pergunta encontrada.',

  // Trust Bar
  home_trust_badge: 'Confiança Global',
  home_trust_title: 'Confiado por Marcas Líderes',
  home_trust_desc: 'Fazemos parcerias com as maiores plataformas de e-commerce do mundo para fornecer serviços de promoção verificados.',

  // Feature Section
  feature_1_title: 'Pagamentos Instantâneos',
  feature_1_desc: 'Receba seus ganhos creditados imediatamente após a conclusão do pedido. Saque a qualquer momento sem atrasos.',
  feature_1_detail_1: 'Crédito de comissão em tempo real',
  feature_1_detail_2: 'Múltiplas opções de saque',
  feature_1_detail_3: 'Sem valor mínimo de saque',
  feature_2_title: 'Plataforma Segura',
  feature_2_desc: 'Criptografia de nível bancário protege seus dados e ganhos. Confiada por milhares de usuários em todo o mundo.',
  feature_2_detail_1: 'Criptografia SSL ativada',
  feature_2_detail_2: 'Autenticação de dois fatores',
  feature_2_detail_3: 'Auditorias de segurança regulares',
  feature_2_detail_4: 'Privacidade de dados garantida',
  feature_3_title: 'Horários Flexíveis',
  feature_3_desc: 'Trabalhe quando quiser, onde quer que esteja. Complete pedidos no seu próprio ritmo, sem horário fixo.',
  feature_3_detail_1: 'Sem horário fixo de trabalho',
  feature_3_detail_2: 'Trabalhe de qualquer lugar',
  feature_3_detail_3: 'Escolha seu próprio ritmo',
  feature_3_detail_4: 'Disponibilidade aos fins de semana',
  feature_4_title: 'Ganhos Progressivos',
  feature_4_desc: 'Desbloqueie taxas de comissão mais altas à medida que completa mais pedidos. Cresça sua renda com cada upgrade de nível.',
  feature_4_detail_1: 'Taxas de comissão por nível',
  feature_4_detail_2: 'Upgrades de nível automáticos',
  feature_4_detail_3: 'Recompensas por desempenho',
  feature_5_title: 'Plataforma Global',
  feature_5_desc: 'Trabalhe com marcas internacionais de qualquer lugar do mundo. Suporte multimoedas incluído.',
  feature_5_detail_1: 'Disponível no mundo todo',
  feature_5_detail_2: 'Suporte multimoedas',
  feature_5_detail_3: 'Métodos de pagamento locais',
  feature_6_title: 'Suporte 24/7',
  feature_6_desc: 'Nossa equipe de suporte dedicada está sempre pronta para ajudar. Obtenha assistência via chat ao vivo, e-mail ou telefone.',
  feature_6_detail_1: 'Chat ao vivo disponível',
  feature_6_detail_2: 'Suporte por e-mail 24/7',
  feature_6_detail_3: 'Assistência por telefone',
  feature_6_detail_4: 'FAQ abrangente',
  feature_7_title: 'Programa de Indicação',
  feature_7_desc: 'Ganhe renda extra convidando amigos. Obtenha comissões vitalícias sobre os ganhos de seus indicados.',
  feature_7_detail_1: 'Ganhos de indicação vitalícios',
  feature_7_detail_2: 'Indicações ilimitadas',
  feature_7_detail_3: 'Ferramentas de compartilhamento fáceis',
  feature_7_detail_4: 'Incentivos de bônus',
  feature_8_title: 'Multimoedas',
  feature_8_desc: 'Suporte para as principais moedas e métodos de pagamento. Escolha o que funciona melhor para você.',
  feature_8_detail_1: 'Suporte para USD, EUR, GBP',
  feature_8_detail_2: 'Transferência bancaria disponível',
  feature_8_detail_3: 'Integração de e-wallet',
  feature_8_detail_4: 'Opções de cripto em breve',
  feature_9_title: 'Notificações Instantâneas',
  feature_9_desc: 'Mantenha-se atualizado com alertas em tempo real para novos pedidos, ganhos e atividades da conta.',
  feature_9_detail_1: 'Notificações push',
  feature_9_detail_2: 'Alertas por e-mail',
  feature_9_detail_3: 'Atualizações por SMS',
  feature_9_detail_4: 'Mensagens no aplicativo',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Processo Simples',
  home_how_it_works_title: 'Como Funciona',
  home_how_it_works_subtitle: 'Comece a ganhar em 4 passos simples. Nenhuma experiência é necessária, basta seguir o processo e ver seus ganhos crescerem.',
  home_cta_ready_title: 'Pronto para Começar sua Jornada?',
  home_cta_ready_desc: 'Junte-se a milhares de usuários que já estão ganhando diariamente. Sua primeira comissão está a apenas alguns minutos de distância!',
  home_cta_avg_time: 'Tempo médio para o primeiro ganho:',
  home_cta_15_mins: '15 minutos',
  home_cta_new_users: 'Novos usuários hoje:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'Vagas Limitadas Disponíveis este Mês',
  home_cta_main_title: 'Comece a Ganhar Dinheiro',
  home_cta_today: 'Hoje mesmo!',
  home_cta_main_desc: 'Junte-se a milhares de usuários que já ganham comissões diárias. Sem experiência necessária, horários flexíveis, pagamentos instantâneos. Sua liberdade financeira começa aqui.',
  home_cta_spots_remaining: 'Vagas Restantes',
  home_cta_new_users_today: 'Novos Usuários Hoje',
  home_cta_create_account: 'Criar Conta Gratuita',
  home_cta_sign_in: 'Entrar',
  home_cta_secure: '100% Seguro',
  home_cta_payouts: 'Saques em 24-48h',
  home_cta_rating: 'Avaliação 4.9/5',
  home_cta_active_users: 'Usuários Ativos',
  home_cta_total_paid: 'Total Pago',
  home_cta_orders_done: 'Tarefas concluídas',
  home_cta_satisfaction: 'Satisfação',
  home_cta_guarantee_title: 'Garantia de Reembolso',
  home_cta_guarantee_desc: 'Não está satisfeito? Receba seu depósito de volta em até 7 dias',

  // Footer Branding & Extras
  footer_brand_desc: 'A plataforma líder mundial em promoção de e-commerce. Junte-se à nossa rede global de promotores hoje e comece a ganhar comissões das melhores marcas.',
  footer_ssl_secure: 'Segurança SSL',
  footer_aes_256: 'Criptografia AES-256',
  footer_cookie_policy: 'Política de Cookies',
  footer_disclaimer: 'Aviso Legal',
  footer_all_rights: 'Todos os direitos reservados.',

  // Announcements
  announcement_withdrawal_delay_title: 'Atraso no Processamento de Saques',
  announcement_withdrawal_delay_summary: 'Os saques podem levar até 72 horas devido ao alto volume. Por favor, planeje-se adequadamente.',
  announcement_date_june_14: '14 de junho de 2025',

  // How It Works Steps
  step_1_title: 'Cadastre-se',
  step_1_desc: 'Leva menos de 2 minutos para criar sua conta.',
  step_1_detail_1: 'Insira suas informações básicas',
  step_1_detail_2: 'Verifique seu endereço de e-mail',
  step_1_detail_3: 'Proteja sua conta',
  step_1_detail_4: 'Acesso imediato ao painel',
  step_2_title: 'Escolha a Tarefa',
  step_2_desc: 'Escolha entre as tarefas de promoção disponíveis.',
  step_2_detail_1: 'Filtrar por plataforma',
  step_2_detail_2: 'Ver taxas de comissão',
  step_2_detail_3: 'Aceitar múltiplas tarefas',
  step_2_detail_4: 'Atualizações de tarefas em tempo real',
  step_3_title: 'Conclua a Tarefa',
  step_3_desc: 'Complete as tarefas conforme as instruções.',
  step_3_detail_1: 'Instruções fáceis de seguir',
  step_3_detail_2: 'Envio rápido de tarefas',
  step_3_detail_3: 'Verificação automática',
  step_3_detail_4: 'Interface amigável para dispositivos móveis',
  step_4_title: 'Ganhe e Saque',
  step_4_desc: 'Seja pago por cada tarefa concluída.',
  step_4_detail_1: 'Rastreamento de ganhos em tempo real',
  step_4_detail_2: 'Limite mínimo de saque baixo',
  step_4_detail_3: 'Múltiplos métodos de pagamento',
  step_4_detail_4: 'Suporte a saques 24/7',

  // Redesigned Footer
  footer_stay_loop_title: 'Fique por dentro',
  footer_stay_loop_desc: 'Receba as últimas atualizações, dicas e ofertas exclusivas diretamente na sua caixa de entrada.',
  footer_subscribe: 'Inscrever-se',
  footer_subscribe_placeholder: 'Digite seu endereço de e-mail',
  footer_trusted_secure: 'CONFIÁVEL E SEGURO:',
  footer_ssl_secured: 'Segurança SSL',
  footer_ssl_secured_desc: 'SSL de 256 bits',
  footer_aes_encryption: 'Criptografia AES-256',
  footer_aes_encryption_desc: 'Nível bancário',
  footer_kyc_compliant: 'Conforme KYC',
  footer_kyc_compliant_desc: 'Verificado',
  footer_gdpr_compliant: 'Conforme GDPR',
  footer_gdpr_compliant_desc: 'Dados Protegidos',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Certificado',
  footer_platform: 'PLATAFORMA',
  footer_support: 'SUPORTE',
  footer_legal: 'LEGAL',
  footer_help_center: 'Centro de ajuda',
  footer_contact_us: 'Contate-nos',
  footer_payments_label: 'Pagamentos:',
  home_live_activity_title: 'Atividade da Plataforma ao Vivo',
  home_recent_activity_title: 'Atividade Recente',
  home_total_commissions_paid: 'Total de Comissões Pagas',
  home_active_users_online: 'Usuários Ativos Online',
  home_tasks_completed_today: 'Tarefas Concluídas Hoje',
  account_security_row_title: 'Configurações de Segurança',
  security_login_pw: 'Senha de Login',
  security_login_pw_desc: 'Altere a senha de login da sua conta',
  security_change_btn: 'Alterar',
  security_set_withdrawal_pw_title: 'Definir Senha de Saque',
  security_set_withdrawal_pw_desc: 'Crie um PIN separado para autorizar saques',
  security_set_withdrawal_pw_btn: 'Definir PIN',
  security_change_withdrawal_pw_title: 'Alterar Senha de Saque',
  security_change_withdrawal_pw_desc: 'Atualize seu PIN de saque existente',
  security_change_withdrawal_pw_btn: 'Alterar',
  security_modal_set_withdrawal_title: 'Definir Senha de Saque',
  security_modal_set_withdrawal_subtitle: 'Este PIN será necessário toda vez que você fizer um saque.',
  security_modal_change_withdrawal_title: 'Alterar Senha de Saque',
  security_field_current_pin: 'PIN de Saque Atual',
  security_field_new_pin: 'Novo PIN de Saque',
  security_field_new_pin_6: 'Novo PIN de Saque (6 dígitos)',
  security_field_confirm_pin: 'Confirmar PIN',
  security_field_confirm_new_pin: 'Confirmar Novo PIN',
  security_placeholder_pin_dots: '......',
  security_pw_current: 'Senha Atual',
  account_security_tips_title: 'Recomendações de Segurança',
  account_security_tips_desc: 'Melhore a proteção da sua conta seguindo estas simples boas práticas.',
  tip_password_title: 'Senha Forte',
  tip_password_desc: 'Use a combinação de letras, números e símbolos para garantir que sua conta permaneça segura.',
  tip_two_factor_title: 'Verificação de Identidade',
  tip_two_factor_desc: 'Mantenha suas informações de contato atualizadas para receber notificações de segurança importantes.',
  tip_logout_title: 'Sair Regularmente',
  tip_logout_desc: 'Sempre saia da sua conta ao usar computadores públicos ou compartilhados.',
  tip_sharing_title: 'Nunca Compartilhe o Acesso',
  tip_sharing_desc: 'Nossa equipe de suporte nunca pedirá sua senha. Nunca compartilhe suas credenciais com ninguém.',

  // Solicitações de Pedido
  order_requests_title: 'Solicitações de Pedido',
  order_requests_desc: 'Envie uma solicitação para uma nova tarefa ou pedido personalizado. O administrador revisará e atribuirá tarefas com base na sua solicitação.',
  order_requests_new_btn: 'Solicitar Novo Pedido',
  order_requests_table_id: 'ID da Solicitação',
  order_requests_table_data: 'Detalhes da Solicitação',
  order_requests_table_status: 'Status',
  order_requests_table_date: 'Enviado em',
  order_requests_table_actions: 'Ações',
  order_requests_cancel: 'Cancelar',
  order_requests_cancel_confirm: 'Tem certeza de que deseja cancelar esta solicitação de pedido?',
  order_requests_cancel_success: 'Solicitação de pedido cancelada com sucesso.',
  order_requests_create_success: 'Solicitação de pedido enviada com sucesso.',
  order_requests_modal_title: 'Enviar Nova Solicitação de Pedido',
  order_requests_modal_desc: 'Forneça informações detalhadas sobre o pedido que deseja solicitar.',
  order_requests_field_data: 'Dados da Solicitação de Pedido',
  order_requests_field_placeholder: 'ex: Gostaria de solicitar um pedido personalizado para o Pacote Premium.',
  order_requests_btn_submit: 'Enviar Solicitação',
  order_requests_btn_submitting: 'Enviando...',
  order_requests_empty: 'Nenhuma solicitação de pedido encontrada.',
  order_requests_status_pending: 'Pendente',
  order_requests_status_approved: 'Aprovado',
  order_requests_status_rejected: 'Rejeitado',
  order_requests_status_cancelled: 'Cancelado',
  order_requests_terms_title: 'Termos de Pedido Vinculativos',
  order_requests_term_1: 'Novos pedidos serão atribuídos dentro de 24–48 horas após a aprovação.',
  order_requests_term_2: 'Uma vez liberados, os pedidos não podem ser cancelados, pausados ou modificados.',
  order_requests_term_3: 'Todos os pedidos atribuídos devem ser concluídos antes do levantamento.',
  order_requests_term_4: 'A falha na conclusão dos pedidos pode afetar a situação da sua conta.',
  order_requests_term_5: 'Este pedido é final e não pode ser revertido após o envio.',
  order_requests_policy_title: 'Política de Não Cancelamento',
  order_requests_policy_desc: 'Ao enviar este pedido, você reconhece que o novo lote de pedidos é irrevogável. Uma vez confirmado pelo nosso sistema, nenhum cancelamento, modificação ou reembolso será permitido sob qualquer circunstância.',
  order_requests_accept_terms: 'Li e compreendo totalmente os termos acima. Reconheço que, uma vez enviado, este pedido não pode ser cancelado ou modificado, e concordo em concluir todos os pedidos atribuídos.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'Política de Levantamento',
  orders_unlock_req: 'Requisitos de Desbloqueio',
  orders_unlock_desc: 'Complete o seu primeiro lote de {{count}} pedidos para desbloquear permanentemente os levantamentos. Este requisito único garante a integridade da plataforma e evita abusos.',
  orders_daily_limits: 'Limites Diários de Pedidos',
  orders_daily_limit_1: '{{count}} pedidos por lote — deve completar todos antes de solicitar o próximo',
  orders_daily_limit_2: 'Máximo de {{count}} lotes por dia ({{total}} pedidos/dia)',
  orders_comm_rates: 'Taxas de Comissão',
  orders_comm_rates_desc: 'As taxas são determinadas pela plataforma e pelo saldo atual da sua carteira:',
  orders_payout_timeline: 'Cronograma de Pagamento',
  orders_payout_desc: 'Os levantamentos são processados em 24-48 horas. As transferências bancárias podem levar de 3-5 dias úteis. Os levantamentos de criptomoedas são instantâneos.',
  orders_processing_fee: 'Uma taxa de processamento de {{fee}}% aplica-se a todos os levantamentos para cobrir os custos de transação.',
  orders_tips_title: 'Dicas para o Sucesso',
  orders_tips_1: 'Complete pedidos diariamente para criar balanço e maximizar os ganhos',
  orders_tips_2: 'Permaneça na página durante o processamento para garantir a conclusão adequada',
  orders_tips_3: 'Verifique a sua carteira regularmente para acompanhar o crescimento das comissões',
  orders_tips_4: 'Indique amigos para ganhar comissões de bónus nos seus pedidos',
  orders_tips_5: 'Contate o suporte imediatamente se tiver algum problema',
  orders_batch_approx: '{{count}} pedidos/lote × média ${{avg}} = aproximadamente ${{total}} por lote',

  // Settings
  settings_page_title: 'Configurações',
  settings_page_desc: 'Gerencie sua segurança, privacidade e preferências',
  settings_kyc_label: 'Verificação KYC',
  settings_kyc_desc: 'Verificação de identidade',
  settings_security_label: 'Segurança',
  settings_security_desc: 'Gerenciamento de senhas',
  settings_language_label: 'Idioma',
  settings_language_desc: 'Preferências regionais',

  // Support
  support_btn_send: 'Enviar resposta',
  support_edit_message: 'Editar mensagem',
  support_delete_message: 'Excluir mensagem',
  support_delete_confirm: 'Tem certeza de que deseja excluir esta mensagem?',
  support_message_updated: 'Mensagem atualizada com sucesso',
  support_message_deleted: 'Mensagem excluída com sucesso',
  support_err_already_read: 'Não é possível editar uma mensagem após ela ter sido visualizada.',
  // Modal de depósito
  deposit_modal_title_method: "Selecionar método de pagamento",
  deposit_modal_title_gateway: "Selecionar carteira criptográfica",
  deposit_modal_title_plan: "Selecionar plano de depósito",
  deposit_modal_title_details: "Detalhes do depósito",
  deposit_modal_step_method: "Método",
  deposit_modal_step_gateway: "Carteira",
  deposit_modal_step_plan: "Plano",
  deposit_modal_step_details: "Detalhes",
  deposit_modal_credit_card: "Cartão de crédito / débito",
  deposit_modal_bank_transfer: "Transferência bancária",
  deposit_modal_ewallet: "Carteira eletrônica",
  deposit_modal_digital_currency: "Moeda digital",
  deposit_modal_not_available: "Não disponível na sua região",
  deposit_modal_available_recommended: "Disponível — Recomendado",
  deposit_modal_back_to_method: "Voltar aos métodos de pagamento",
  deposit_modal_back_to_gateway: "Voltar para a lista de carteiras",
  deposit_modal_back_to_plan: "Voltar para os planos",
  deposit_modal_digital_selected: "Moeda digital selecionada",
  deposit_modal_digital_hint: "Escolha sua carteira criptográfica para receber o endereço e as instruções.",
  deposit_modal_loading_wallets: "Carregando carteiras...",
  deposit_modal_no_wallets: "Nenhuma carteira criptográfica disponível.",
  deposit_modal_loading_plans: "Carregando planos...",
  deposit_modal_no_plans: "Nenhum plano de depósito disponível no momento.",
  deposit_modal_duration: "Duração",
  deposit_modal_amounts_profits: "Valores e lucros",
  deposit_modal_amount_label: "Valor",
  deposit_modal_profit_label: "Lucro",
  deposit_modal_benefits: "Benefícios",
  deposit_modal_continue: "Continuar",
  deposit_modal_transfer_details: "Detalhes de transferência para {{name}}",
  deposit_modal_deposit_amount: "Valor do depósito",
  deposit_modal_amount_fixed: "Valor fixado pelo seu plano selecionado",
  deposit_modal_txn_id: "ID da transação",
  deposit_modal_txn_optional: "(Opcional)",
  deposit_modal_txn_placeholder: "ex. 0x1a2b3c4d...",
  deposit_modal_screenshot: "Captura de tela",
  deposit_modal_upload_proof: "Carregar comprovante de pagamento",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — Máx 5MB",
  deposit_modal_comments: "Comentários",
  deposit_modal_comments_placeholder: "Qualquer informação extra...",
  deposit_modal_notice: "Após o envio, nossa equipe verificará seu pagamento e creditará sua conta em 5 a 30 minutos.",
  deposit_modal_confirm: "Confirmar depósito",
  deposit_modal_submitting: "Enviando...",
  deposit_modal_err_fields: "Por favor, preencha todos os campos obrigatórios",
  deposit_modal_err_submit: "Ocorreu un erro durante o envio",
  deposit_modal_success: "Depósito solicitado com sucesso!",
  deposit_modal_err_plans: "Falha ao carregar planos de depósito",
  deposit_modal_err_wallets: "Falha ao carregar métodos de pagamento",
  deposit_modal_new_to_crypto: "New to crypto? Learn how to buy digital currency",
  deposit_modal_crypto_label: "Criptográfica",
  orders_insufficient_balance: "Insufficient Balance",
  orders_balance_gap_msg1: "Your current balance is not enough to complete this order.",
  orders_balance_gap_msg2_start: "Please add",
  orders_balance_gap_msg2_end: "to proceed and unlock your commission.",
  orders_btn_add_funds: "Add Funds",
};
